// Configurazione centralizzata dell'applicazione
export interface AppConfig {
  environment: 'development' | 'production';
  backend: {
    url: string;
  };
  paypal: {
    clientId: string;
  };
  google: {
    sheetId: string;
    apiKey: string;
    clientId: string;
  };
  stripe: {
    publicKey: string;
  };
}

class ConfigService {
  private static instance: ConfigService;
  private config: AppConfig;

  private constructor() {
    this.config = this.loadConfig();
  }

  public static getInstance(): ConfigService {
    if (!ConfigService.instance) {
      ConfigService.instance = new ConfigService();
    }
    return ConfigService.instance;
  }

  private loadConfig(): AppConfig {
    // Rileva automaticamente l'ambiente basandosi sul dominio
    const isProductionDomain = window.location.hostname === 'ariadifest.com';
    const isDevelopment = !isProductionDomain;
    

    //sanbox ATUuNOgsoNqaz2UMINBr9hBgEx38Am9hw_VQmTitMFwHhKbXuE0ZOHD7slMt2W7BCk4ZGpQPqBE3PDNH

    return {
      environment: isDevelopment ? 'development' : 'production',
      backend: {
        url: isDevelopment 
          ? 'http://localhost:1212'
          : 'https://api.ariadifest.com'
      },
      paypal: {
        clientId: isDevelopment ? 'ATUuNOgsoNqaz2UMINBr9hBgEx38Am9hw_VQmTitMFwHhKbXuE0ZOHD7slMt2W7BCk4ZGpQPqBE3PDNH' : 'AZLjaBP50pCdvFG2K5z8czSQIgLDs59zxc409FbioXKSPaSVdGOXWyEYCoRmcokO6DO7zDgzxWYdj1_4'
      },
      google: {
        sheetId: process.env.REACT_APP_GOOGLE_SHEET_ID || '1Mog4ucLsdczvymXdAWr_CbPTzqcPmq9q5PWpQimhcCA',
        apiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
        clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '529374738760-jggag86ue4ntkp7j2oibnrko6ee0jdmv.apps.googleusercontent.com'
      },
      stripe:{
        publicKey: isDevelopment ? 'pk_test_51S8RXWEp9lMnoLjY8ZW6OaZj8CuBXF1iKLNztANsf1gY1eSVMIDVXb0xsqC1oNkgbZ46qt6hOc8giiyomVFH4kSo00LLRwiRQ5' : 'pk_live_51S8RXDRHlwhLogHvpTiNJIfOY1iDKrpP3JD6PbRMwtAluQrMAoeAcSOQ2cYyhnxqxpVBvQmdM31EKpOvZYU1cpQF00CEUjwT7T'
      }
    };
  }

  public getConfig(): AppConfig {
    return this.config;
  }

  public getBackendUrl(): string {
    return this.config.backend.url;
  }

  public getPayPalClientId(): string {
    return this.config.paypal.clientId;
  }

  public getStripePublicKey(): string {
    return this.config.stripe.publicKey;
  }

  public isDevelopment(): boolean {
    return this.config.environment === 'development';
  }

  public isProduction(): boolean {
    return this.config.environment === 'production';
  }

  // Debug info
  public getDebugInfo() {
    return {
      hostname: window.location.hostname,
      environment: this.config.environment,
      backendUrl: this.config.backend.url,
      paypalClientId: this.config.paypal.clientId.substring(0, 10) + '...',
      isProductionDomain: window.location.hostname === 'ariadifest.com'
    };
  }
}

// Esporta istanza singleton
export const configService = ConfigService.getInstance();
export default configService;
